<template>
  <div class="mesJustificatifsChargeDocument mt-5">
    <div class="charge-document">
      <div
        class="charge-document-component charte-engagement-component"
        style="cursor: pointer;"
        @click="$bvModal.show('modal-charte-engagement')"
      >
        <div class="charge-document-content">
          <img :src="require('@/assets/layers.png')" /><br />
          CHARTE D'ENGAGEMENTS CF/PN<br />
          <img
            v-if="this.isPresent"
            class="charge-document-icon"
            :src="require('@/assets/check-document.png')"
          />
          <img
            v-if="!this.isPresent"
            class="charge-document-icon"
            :src="require('@/assets/missing-document.png')"
          />
        </div>
      </div>
    </div>

    <b-modal
      centered
      id="modal-charte-engagement"
      ref="modal-charte-engagement"
      @show="resetModale"
      @hidden="resetModale"
    >
      <p class="mes-justificatifs-text mt-3">
        Je soussigné(e) {{ nomLicencie }} {{ prenomLicencie }} m’engage à :
      </p>
      <p class="mes-justificatifs-text mt-5" style="font-style: italic">
        {{ "charte_engagement_modale_text_1" | translate("fr") }}
      </p>
      <p class="mes-justificatifs-text mt-4" style="font-style: italic">
        {{ "charte_engagement_modale_text_2" | translate("fr") }}
      </p>

      <label class="mes-justificatifs-text mt-4" style="font-weight: bold"
        ><input
          type="checkbox"
          class="modal-check-label"
          v-model="isConditionAcceptee"
        />
        {{ "charte_engagement_modale_check" | translate("fr") }}</label
      >

      <p
        v-if="charteEngagementValidationMsg != null"
        class="alert alert-danger text-left global-errors mt-5"
      >
        {{ charteEngagementValidationMsg }}
      </p>

      <template v-slot:modal-title>
        <div class="text-center">
          <img :src="require('@/assets/layers-white.png')" /><br />
          CHARTE D’ENGAGEMENTS CF/PN <br />
          (des Joueurs et Joueuses de NM2, NM3, PNM, NF1, NF2, NF3 et PNF)
        </div>
      </template>

      <template v-slot:modal-footer>
        <div class="w-100 text-center">
          <b-button
            variant="primary"
            @click="sauvegardeConfirmation"
            class="modal-button"
          >
            ENREGISTRER
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import translations from "@/Translations.js";

export default {
  props: ["nomLicencie", "prenomLicencie", "isPresent"],
  data() {
    return {
      charteEngagementValidationMsg: null,
      isConditionAcceptee: false
    };
  },
  filters: {
    translate: function(value, locale) {
      return translations[locale][value];
    }
  },
  methods: {
    sauvegardeConfirmation() {
      if (!this.isConditionAcceptee) {
        this.charteEngagementValidationMsg =
          "Il est nécessaire d’accepter la Charte d’engagements CF/PN pour pouvoir continuer";
        return;
      }

      this.$refs["modal-charte-engagement"].hide();
      this.$emit("getCharteEngagementAcceptee", true);
    },
    resetModale() {
      this.charteEngagementValidationMsg = null;
      this.isConditionAcceptee = this.isPresent;
    }
  }
};
</script>

<style scoped>
.modal-check-label {
  vertical-align: bottom;
  position: relative;
  margin-right: 10px;
}

.charte-engagement-component:hover {
  border-color: #003690;
}
</style>
